import React from "react";
import styled from "styled-components";
import ImageSlider from "../Commponents/ImageSlider";
import image from "../assets/BGlightgrey.png";
import image1 from "../assets/fb (3) 1.png";
import image2 from "../assets/fb (1) 1.png";
import image3 from "../assets/fb (4) 1.png";
import image4 from "../assets/achi1.jpg";
import image5 from "../assets/ourvalues_button.png";
import gifImage from "../assets/brainstorming.gif";
import gifimage1 from "../assets/ideation.gif";
import gifimage2 from "../assets/development.gif";
import gifimage3 from "../assets/QA.gif";
import gifimage4 from "../assets/art n design.gif";
import gifimage5 from "../assets/marketing.gif";
import image6 from "../assets/techstack1.png";
import image7 from "../assets/techstack2.png";
import imagewht from "../assets/BG_white.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const Wrap = styled.div`
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
`;

const Contanier1 = styled.div`
  width: 100%;
  height: 500px;
  background-image: url(${image});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  justify-content: center;
  padding: 100px;
  position: relative;

  @media (max-width: 1350px) {
    padding: 5px;
  }

  @media (max-width: 1024px) {
    padding: 0px 50px 50px 50px;
    height: auto;
    flex-direction: column-reverse;
    align-items: center;
  }

  @media (max-width: 768px) {
    padding: 0px 50px 50px 50px;
    height: auto;
    flex-direction: column-reverse;
    align-items: center;
  }
`;
const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const Contanier2 = styled(Contanier1)`
  flex-direction: column; /* Image left aur Description right */
  align-items: flex-end; /* Right side align */
  background-image: url(${imagewht});

  @media (max-width: 1350px) {
    padding: 5px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const Description = styled.div`
  width: 60%;
  color: #000000;
  font-size: 1.2rem;
  background-color: white;
  padding: 20px;
  border-radius: 30px;
  margin-left: 150px;
  padding-top: 80px;
  line-height: 1.5;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.2); /* Light border effect */

  @media (max-width: 1350px) {
    width: 80%;
    margin-left: 70px;
  }

  @media (max-width: 1024px) {
    width: 90%;
    margin-left: 0;
    padding: 30px;
    margin-top: 30px;
    text-align: center;
  }

  @media (max-width: 768px) {
    width: 90%;
    margin-left: 0;
    padding: 30px;
    text-align: center;
  }
`;

const DescriptionRight = styled(Description)`
  margin-left: 0;
  margin-right: 170px; /* Right side alignment */
  text-align: right;

  @media (max-width: 1350px) {
    width: 80%;
    margin-right: 70px;
  }

  @media (max-width: 1024px) {
    margin-right: 0;
    text-align: center;
     margin-bottom: 30px;
  }

  @media (max-width: 768px) {
    margin-right: 0;
    text-align: center;
    margin-bottom: 30px;
  }
`;

const TopLeftImageContainer = styled.div`
  position: absolute;
  top: -80px;
  left: -30px;
  width: 300px;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: white;
  background-image: url(${image2});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 10px;

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
    font-size: 0.6rem;
    top: -60px;
    left: -20px;
  }
`;

const TopRightImageContainer = styled(TopLeftImageContainer)`
  left: auto;
  right: -30px; /* Right side shift */
`;

const ImageContainer = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 120px;
  z-index: 2;
  right: 180px;

  @media (max-width: 1350px) {
    right: 30px;
  }

  @media (max-width: 1024px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
  }

  @media (max-width: 768px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
  }
`;

const ImageContainerLeft = styled(ImageContainer)`
  right: auto;
  left: 150px; /* Left side shift */

  @media (max-width: 2100px) {
    left: 100px;
  }

  @media (max-width: 1500px) {
    left: 40px;
  }

  @media (max-width: 1350px) {
    left: 10px;
  }

  @media (max-width: 1024px) {
    position: relative;
    top: 0;
    margin-bottom: 30px;
    left: 0;
    width: 80%;
  }
  @media (max-width: 768px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  max-width: 400px;
  border-radius: 10px;

  @media (max-width: 768px) {
    max-width: 300px;
  }
`;
const Contanier3 = styled.div`
  width: 100%;
  box-sizing: border-box;
  position: relative;
  background: linear-gradient(
      to bottom,
      rgba(0, 238, 255, 0.9),
      transparent 20%
    ),
    linear-gradient(to top, rgba(0, 238, 255, 0.9), transparent 20%),
    radial-gradient(
      ellipse at center,
      rgba(0, 238, 255, 0.9) 10%,
      transparent 110%
    ),
    url(${image});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
  min-height: 600px;

  @media (max-width: 1024px) {
    padding: 40px 0;
    min-height: 500px;
  }

  @media (max-width: 768px) {
    padding: 30px 0;
    min-height: 400px;
    background-size: contain;
  }

  @media (max-width: 480px) {
    padding: 20px 0;
    min-height: 350px;
    background-position: top;
  }
`;

const VisionTitle = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 30px;
  @media (max-width: 480px) {
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  width: 80%;
  box-sizing: border-box;
  padding: 100px;
   /* background-color: purple;  */
  justify-content: center;

  @media (max-width: 1500px) {
    width: 100%;
    margin: 50px;
    margin-top: 50px;
  }

  @media (max-width: 1350px) {
    width: 100%;
    margin: 50px;
    margin-top: 50px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
    /* padding: 80px; */
    width: 90%;
  }

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
    margin-top: 50px;
    padding: 0%;
    /* padding: 5px; */
    width: 100%;
    height: auto; /* Poori screen height le raha */
    align-items: center; /* Vertical center */
    justify-content: center; /* Horizontal center */
    text-align: center;
  }

  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
    margin-top: 50px;
    padding: 5px;
    width: 100%;
    height: auto; /* Poori screen height le raha */
    align-items: center; /* Vertical center */
    justify-content: center; /* Horizontal center */
    text-align: center;
  }
`;

const GridImage = styled.img`
  width: 335px;
  height: 114px;
  border-radius: 10px;
  object-fit: cover;

  @media (max-width: 1350px) {
    width: 300px;
    height: auto;
    justify-content: center;
    align-items: center;
    /* margin: 20px; */
  }

  @media (max-width: 1024px) {
    width: 300px;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 85%;
    height: auto;
    position: absolute;
    display: block;
    position: absolute;
    /* background-color: #0ab2f5; */
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    width: 85%;
    height: auto;
    position: absolute;
    display: block;
    position: absolute;
    /* background-color: #0ab2f5; */
    margin: 0 auto;
  }
`;

const GridItem = styled.div`
  position: relative;
  display: inline-block;
  /* background-color: red; */
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1350px) {
    width: 100%;
  }

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 90%;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Vertical center */
    align-items: center; /* Horizontal center */
    margin: 0 auto; /* Horizontally center if it's a block */
    text-align: center;
  }

  @media (max-width: 480px) {
    width: 90%;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Vertical center */
    align-items: center; /* Horizontal center */
    margin: 0 auto; /* Horizontally center if it's a block */
    text-align: center;
  }
`;

const OverlayText = styled.span`
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  color: #000000;
  border-radius: 5px;
  /* background-color: pink; */
  font-size: 20px;

  @media (max-width: 2100px) {
    top: 40px;
    left: 40%;
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    top: 35px;
    font-size: 18px;
  }

  @media (max-width: 768px) {
    top: 50px;
    left: 41%;
    font-size: 20px;
    z-index: 7;
  }

  @media (max-width: 480px) {
    top: 50px;
    left: 41%;
    /* position: relative; */
    font-size: 16px;
    z-index: 7;
  }
`;
const GifContainer = styled.div`
  position: absolute;
  bottom: 121px;
  left: 70px; /* Adjust this value to position the GIF */
  width: 196px; /* Adjust the width as needed */
  height: 207px;
  z-index: 5;

  @media (max-width: 768px) {
    position: relative;
    top: 20px;
    right: 0;
    width: 50%;
  }
`;
const GifContainer3 = styled.div`
  position: absolute;
  bottom: 121px;
  /* background-color: #00ff37; */
  left: 50px; /* Adjust this value to position the GIF */
  width: 196px; /* Adjust the width as needed */
  height: 207px;
  z-index: 2;

  @media (max-width: 2300px) {
    bottom: -0px;
    width: 150px;
    height: 150px;
    left: 230px;
  }

  @media (max-width: 1350px) {
    bottom: -0px;
    width: 150px;
    height: 150px;
    left: 190px;
  }

  @media (max-width: 1024px) {
    bottom: -0px;
    width: 130px;
    height: 130px;
    left: 190px;
  }

  @media (max-width: 768px) {
    position: relative;
    align-items: center;
    justify-content: center;
    text-align: center;
    bottom: 30px;
    left: 40px;
    padding-left: 35%;
    margin-right: 20px;
    /* right: 0; */
    width: 70%;
  }
  @media (max-width: 480px) {
    align-items: center;
    justify-content: center;
    text-align: center;
    bottom: 0px;
    left: 30px;
    padding-left: 35%;
    margin-right: 20px;
    /* right: 0; */
    width: 70%;
  }
`;
const GifContainer2 = styled.div`
  position: absolute;
  bottom: 145px;
  left: 65px;
  width: 196px;
  height: 207px;

  @media (max-width: 1024px) {
    bottom: 100px;
    left: 50px;
    width: 180px;
    height: auto;
  }

  @media (max-width: 768px) {
    position: relative;
    top: 20px;
    left: 0;
    bottom: auto;
    width: 80%;
    height: auto;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: auto;
    top: 10px;
  }
`;
const GifContainer1 = styled.div`
  position: absolute;
  bottom: 132px;
  left: 50px;
  width: 196px;
  height: 207px;

  @media (max-width: 1024px) {
    width: 180px;
    height: 190px;
  }

  @media (max-width: 768px) {
    position: relative;
    top: 20px;
    left: 0;
    width: 80%;
    height: auto;
  }

  @media (max-width: 480px) {
    width: 90%;
  }
`;

const ResponsiveGif = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const Container4 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
  gap: 20px;

  @media (max-width: 1024px) {
    padding: 40px 0;
    gap: 18px;
  }

  @media (max-width: 768px) {
    padding: 30px 0;
    gap: 15px;
  }

  @media (max-width: 480px) {
    padding: 20px 0;
    gap: 10px;
  }
`;

const Div = styled.div`
  width: 80%;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 150px;

  @media (max-width: 1024px) {
    width: 90%;
    height: 160px;
    border-radius: 120px;
    gap: 18px;
  }

  @media (max-width: 768px) {
    width: 95%;
    height: 140px;
    border-radius: 100px;
    gap: 15px;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: auto;
    padding: 20px;
    border-radius: 80px;
    gap: 10px;
  }
`;
const StyledParagraph = styled.p`
  text-align: left;
  align-items: flex-start;
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  max-width: 80%;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 1350px) {
    padding-left: 150px;
  }

  @media (max-width: 1024px) {
    font-size: 16px;
    max-width: 90%;
    padding: 15px;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    max-width: 95%;
    padding: 10px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    max-width: 100%;
    padding: 5px;
  }
`;
const StyledParagraph2 = styled.p`
  text-align: left;
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  max-width: 80%;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 1024px) {
    font-size: 16px;
    max-width: 90%;
    padding: 15px;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    max-width: 95%;
    padding: 10px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    max-width: 100%;
    padding: 5px;
  }
`;

const ResponsiveImage = styled.img`
  width: 95%;
  /* max-width: 150px; */
  height: auto;
  object-fit: contain;

  @media (max-width: 1024px) {
    width: 90%;
    max-width: 730px;
  }

  @media (max-width: 768px) {
    width: 90%;
    max-width: 650px;
  }

  @media (max-width: 480px) {
    width: 90%;
    max-width: 450px;
  }
`;
const ResponsiveImage2 = styled.img`
  width: 95%;
  /* max-width: 150px; */
  height: auto;
  object-fit: contain;

  @media (max-width: 1024px) {
    width: 90%;
    max-width: 730px;
  }

  @media (max-width: 768px) {
    width: 90%;
    max-width: 650px;
  }

  @media (max-width: 480px) {
    width: 90%;
    max-width: 450px;
  }
`;

const ImageResponse = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  /* background-color: #002fff; */

  @media (max-width: 1500px) {
    max-width: 300px;
  }

  @media (max-width: 1350px) {
    max-width: 300px;
  }
  @media (max-width: 1024px) {
    max-width: 300px;
  }

  @media (max-width: 768px) {
    max-width: 230px;
  }

  @media (max-width: 480px) {
    max-width: 230px;
  }
`;
const ImageResponse1 = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  /* background-color: red; */

  @media (max-width: 768px) {
    max-width: 300px;
  }

  @media (max-width: 480px) {
    max-width: 230px;
  }
`;

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,     // Animation duration
      once: false,        // Her baar animate karein jab visible ho
      mirror: true,       // Scroll up par bhi animate ho
      easing: 'ease-in-out',
      anchorPlacement: 'top-bottom', // Kab animate ho (jab top of element bottom of viewport ko touch kare)
      delay: 100
    });

  }, []);
  return (
    <>
      <Wrap>
        {/* <ImageSlider /> */}
        <BannerImage src={image4} alt="About Us Banner" />
        <Contanier1>
          <Description data-aos="flip-right">
            <TopLeftImageContainer data-aos="fade-right">About Codenary Devs</TopLeftImageContainer>
            <StyledParagraph2 data-aos="flip-left">
              Ever had a brainchild so brilliant it practically begged to exist?
              That's where we come in. Codenary Devs is your go-to team for
              turning "what ifs" into "heck yes!" We build mobile apps, games,
              and websites that don't just function—they entertain, engage, and
              keep people coming back for more. Gamification is our secret
              sauce, and trust us, it's delicious. Ready to watch your idea
              sparkle like a diamond in a spotlight? Let's make some digital
              magic together!
            </StyledParagraph2>
          </Description>
          <ImageContainer>
            <StyledImage data-aos="flip-left" 
              src={image1} alt="Business Image" />
          </ImageContainer>
        </Contanier1>

        {/* Container 2 - Image Left, Description Right */}
        <Contanier2>
          <ImageContainerLeft>
            <StyledImage data-aos="flip-left" src={image3} alt="Business Image" />
          </ImageContainerLeft>
          <DescriptionRight data-aos="flip-right">
            <TopRightImageContainer data-aos="fade-right">Our Mission</TopRightImageContainer>
            <StyledParagraph>
              Normal is overrated, and boring is banned. At Codenary Devs, we
              don't just create digital products—we craft experiences that
              delight, challenge, and stick like your favorite song on repeat.
              Whether it's an app, a game, or a website, we mix creativity,
              strategy, and a sprinkle of mischief to make something
              extraordinary. Why settle for forgettable when you can build
              something legendary? Let's talk today!
            </StyledParagraph>
          </DescriptionRight>
        </Contanier2>
        <Contanier3>
          <VisionTitle div data-aos="flip-right">Our Vision</VisionTitle>
          <ImageGrid>
            <GridItem  data-aos="zoom-in-left">
              <OverlayText >Brainstorming</OverlayText>
              <GridImage src={image5} alt="Vision Image 1" />
              <GifContainer3 >
                <ImageResponse src={gifImage} alt="Brainstorm GIF" />
              </GifContainer3>
            </GridItem>

            <GridItem data-aos="zoom-in-right">
              <OverlayText>Ideation</OverlayText>
              <GridImage src={image5} alt="Vision Image 1" />
              <GifContainer3>
                <ImageResponse src={gifimage1} alt="Brainstorm GIF" />
                {/* <img
                  style={{ width: "350px", height: "350px" }}
                  src={gifimage1}
                  alt="Brainstorm GIF"
                /> */}
              </GifContainer3>
            </GridItem>

            <GridItem data-aos="zoom-in-left">
              <OverlayText>Development</OverlayText>
              <GridImage src={image5} alt="Vision Image 1" />
              <GifContainer3>
                <ImageResponse src={gifimage2} alt="Brainstorm GIF" />
                {/* <img
                  style={{ width: "350px", height: "350px" }}
                  src={gifimage2}
                  alt="Brainstorm GIF"
                /> */}
              </GifContainer3>
            </GridItem>

            <GridItem data-aos="zoom-in-right">
              <OverlayText>QA</OverlayText>
              <GridImage src={image5} alt="Vision Image 1" />
              <GifContainer3>
                <ImageResponse src={gifimage3} alt="Brainstorm GIF" />
                {/* <img
                  style={{ width: "350px", height: "350px" }}
                  src={gifimage3}
                  alt="Brainstorm GIF"
                /> */}
              </GifContainer3>
            </GridItem>

            <GridItem data-aos="zoom-in-left">
              <OverlayText>Art and Design</OverlayText>
              <GridImage src={image5} alt="Vision Image 1" />
              <GifContainer3>
                <ImageResponse src={gifimage4} alt="Brainstorm GIF" />
                {/* <img
                  style={{ width: "350px", height: "350px" }}
                  src={gifimage4}
                  alt="Brainstorm GIF"
                /> */}
              </GifContainer3>
            </GridItem>

            <GridItem data-aos="zoom-in-right">
              <OverlayText>Marketing</OverlayText>
              <GridImage src={image5} alt="Vision Image 1" />
              <GifContainer3>
                <ImageResponse src={gifimage5} alt="Brainstorm GIF" />
                {/* <img
                  style={{ width: "350px", height: "350px" }}
                  src={gifimage5}
                  alt="Brainstorm GIF"
                /> */}
              </GifContainer3>
            </GridItem>
          </ImageGrid>
        </Contanier3>
        <Container4>
          <Div data-aos="flip-up"
     >
            <ResponsiveImage src={image6} alt="Image 1" />
          </Div>
          <Div data-aos="flip-down"
     >
            <ResponsiveImage2 src={image7} alt="Image 2" />
          </Div>
        </Container4>
      </Wrap>
    </>
  );
};

export default AboutUs;
